import React from 'react'
import { useAuth } from '../hooks/contexts/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';
import PageLoading from '../PageLoading';

function AuthticateUser({ element }) {
  const { isLoggedIn, isLoading } = useAuth();
  if (isLoading) {
    return <PageLoading />;
  }

  // If the user is logged in, navigate to the home page
  if (isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  // If not logged in, render the Outlet for child routes (login, signup, etc.)
  return <Outlet> {element} </Outlet>;
}

export default AuthticateUser
